import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { StoreModule } from '@ngrx/store';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import {
  navigationReducer,
  navigationSelectorKey,
} from './+state/navigation.selectors';
import { NavigationEffects } from './+state/navigation.effects';
import { EcmpLogosEffects } from './+state/ecmp-logos';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(navigationSelectorKey, navigationReducer),
  ],
  providers: [
    provideBootstrapEffects([EcmpLogosEffects, NavigationEffects]),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreNavigationStoreModule {}
